import request from '@/router/axios'
import env from '@/config/env'

/**
 * 获取线路列表
 * @param params
 */
export const lineList = (params) => {
  return request({
    url: env.ferryUrl + '/flightManage/getLinePage',
    method: 'POST',
    data: params
  })
}

/**
 * 保存
 * @param data
 */
export const save = (data) => {
  return request({
    url: env.ferryUrl + '/flightManage/saveFlightPlan',
    method: 'POST',
    data
  })
}
/**
 * 删除班次
 * @param id
 */
export const remove = (id) => {
  return request({
    url: env.ferryUrl + `/flightManage/deleteFlightById/${id}`,
    method: 'DELETE'
  })
}

/**
 * 复制班次
 * @param data
 */
export const corpyPlan = (data) => {
  return request({
    url: env.ferryUrl + '/flightManage/copyFlight',
    method: 'POST',
    data
  })
}

/**
 * 分页列表
 * @param params
 */
export const listPage = (params) => {
  return request({
    url: env.ferryUrl + '/flightManage/page',
    method: 'POST',
    data: params
  })
}
/**
 * 查看详情
 * @param flightId
 */
export const details = (flightId) => {
  return request({
    url: env.ferryUrl + `/flightManage/queryFlightDetails/${flightId}`,
    method: 'POST'
  })
}

/**
 * 调整运力
 * @param data
 */
export const modifyDr = (data) => {
  return request({
    url: env.ferryUrl + '/flightManage/adjustCapacity',
    method: 'POST',
    data
  })
}

/**
 * 老的 获取供应商下拉列表
 * @param merchId
 */
export const getMerchantSelect = () => {
  return request({
    url: env.ferryUrl + '/flightManage/queryMerchantList',
    method: 'get'
  })
}

/**
 * 新的 获取供应商下拉列表
 * @param merchId
 */
export const getPageMerchant = (lineId) => {
  return request({
    url: env.ferryUrl + `/flightManage/getPageMerchant/${lineId}`,
    method: 'get'
  })
}

/**
 * 获取座位列表下拉数据
 */
export const getSeatSelect = () => {
  return request({
    url: env.ferryUrl + '/flightManage/findSeatsList',
    method: 'post'
  })
}

/**
 * 获取座位等级下拉数据
 */
export const getSeatNumSelect = (seat) => {
  return request({
    url: env.ferryUrl + `/flightManage/findBySeat/${seat}`,
    method: 'post'
  })
}

/**
 * 获取价格方案列表
 * @param data
 */
export const priceSchemeList = (data) => {
  return request({
    url: env.ferryUrl + '/flightManage/getAllPriceList',
    method: 'post',
    data
  })
}
/**
 * 获取站点规则
 * @param data
 */
export const getStationRule = (data) => {
  return request({
    url: env.ferryUrl + '/flightManage/getStationRule',
    method: 'POST',
    data
  })
}

/**
 * 获取司机信息
 * @param data
 */
export const getDriver = (data) => {
  return request({
    url: env.ferryUrl + '/flightManage/getCarAndDriverInfo',
    method: 'POST',
    data
  })
}

/**
 * 获取司机信息
 * @param data
 */
export const getDriverByLineId = (lineId) => {
  return request({
    url: env.ferryUrl + `/flightManage/carAndDriverInfoList/${lineId}`,
    method: 'get'
  })
}

/**
 * 停班
 * @param data
 */
export const stopFlight = (data) => {
  return request({
    url: env.ferryUrl + '/flightManage/stopFlight',
    method: 'POST',
    data
  })
}

/**
 * 开班
 * @param data
 */
export const openFlight = (data) => {
  return request({
    url: env.ferryUrl + '/flightManage/openFlight',
    method: 'POST',
    data
  })
}

/**
 * 线路
 */
export const getAllLine = () => {
  return request({
    url: env.ferryUrl + '/flightManage/findAllStation',
    method: 'POST'
  })
}

/**
 * 保存单子
 * @param data
 */
export const saveFileimg = (data) => {
  return request({
    url: env.ferryUrl + '/flightManage/saveCheckTicket',
    method: 'POST',
    data
  })
}

/**
 * 根据班次id 查看详情
 * @param id
 */
export const getFlightDetailsById = (id) => {
  return request({
    url: env.ferryUrl + `/flightManage/queryFlightDetails/${id}`,
    method: 'post'
  })
}

/**
 * 编辑班次
 * @param data
 */
export const editFlight = (data) => {
  return request({
    url: env.ferryUrl + '/flightManage/editFlight',
    method: 'post',
    data
  })
}

export const batchDelete = (ids) => {
  return request({
    url: env.ferryUrl + '/flightManage/delBatchFlight',
    method: 'delete',
    data: {
      flightPlanIds: ids
    }
  })
}

// 获取操作集合类型分类
export const bizLogOperateType = (params) => {
  return request({
    url: env.ferryUrl + '/bizLog/getBizLogOperateType',
    method: 'get',
    params
  })
}

// 分页获取日志
export const pages = (params) => {
  return request({
    url: env.ferryUrl + '/bizLog/page',
    method: 'post',
    data: params
  })
}
// 获取标签
export const labelList = (params) => {
  return request({
    url: env.ferryUrl + '/label/list',
    method: 'get',
    params
  })
}
// 保存标签
export const labelSave = (params) => {
  return request({
    url: env.ferryUrl + '/label/save',
    method: 'post',
    data: params
  })
}
// 查询操作人
export const sysUserList = (params) => {
  return request({
    url: env.ferryUrl + '/user/getSysUserList',
    method: 'get',
    params
  })
}
// 获取线路司机排序
export const getSelectedDriver = (params) => {
  return request({
    url: env.ferryUrl + '/flight/driver/getById/' + params.merchantId + '/' + params.lineId,
    method: 'get'
  })
}
// 保存线路司机排序
export const saveSelectedDriver = (params) => {
  return request({
    url: env.ferryUrl + '/flight/driver/saveDriverFlightSort',
    method: 'post',
    data: params
  })
}
